/* lockunlock.icon.svg.js */

"use strict";
module.exports = {
    icon: `
        <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M13.5,7.6h-0.4c0-1.6,0-2.9,0-2.9C13,2.1,10.8,0,8,0S3,2.1,2.9,4.7v2.9H2.5C2.1,7.6,1.8,8,1.8,8.3v7
                c0,0.4,0.3,0.7,0.7,0.7h10.9c0.4,0,0.7-0.3,0.7-0.7v-7C14.2,8,13.9,7.6,13.5,7.6z M5.2,4.7L5.2,4.7C5.3,3.3,6.5,2.2,8,2.2
                s2.7,1.1,2.8,2.5v2.9H5.2V4.7z M8.7,11.6l0.4,2.1c0,0.3-0.7,0.6-1,0.6h0c-0.3,0-1-0.2-1-0.6l0.4-2.1c0,0,0,0,0,0
                c-0.4-0.2-0.6-0.6-0.6-1c0-0.6,0.5-1.1,1.2-1.1s1.2,0.5,1.2,1.1C9.3,11,9.1,11.4,8.7,11.6C8.7,11.6,8.7,11.6,8.7,11.6z"/>
        </svg>`,
    toggledIcon: `
        <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M14.2,8.3v7c0,0.4-0.3,0.7-0.7,0.7H2.5c-0.4,0-0.7-0.3-0.7-0.7v-7c0-0.4,0.3-0.7,0.7-0.7h0.4V4.7
                C3,2.1,5.2,0,8,0s5,2.1,5.1,4.7c0,0,0,0.3,0,0.4s0,0.4-0.4,0.4c-0.5,0-1.2,0-1.5,0c-0.5,0-0.4-0.4-0.4-0.4V4.7
                C10.7,3.3,9.5,2.2,8,2.2S5.3,3.3,5.2,4.7l0,0v2.9h8.3C13.9,7.6,14.2,8,14.2,8.3z M8.7,11.6c0.4-0.2,0.6-0.6,0.6-1
                c0-0.6-0.5-1.1-1.2-1.1S6.9,10,6.9,10.6c0,0.4,0.2,0.8,0.6,1c0,0,0,0,0,0l-0.4,2.1c0,0.3,0.7,0.6,1,0.6h0c0.3,0,1-0.2,1-0.6
                L8.7,11.6C8.7,11.6,8.7,11.6,8.7,11.6z"/>
        </svg>`,
};
